import MeetingHistory from "./MeetingHistory";
import Students from "./Students";
import Subjects from "./Subjects";
import {
  Auth0AccountRole,
  TutorAdminResponse,
  StudentLimitedResponse,
} from "client/openapi";
import { APIResponse, PageStatus } from "types";
import { useContext, useState } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";
import AdministrativeInfo from "pages/manage/students/[id]/StudentInfoTab/AdministrativeInfo";
import PersonFormsSection from "components/Forms/PersonFormsSection";
import PersonTasksSection from "components/Tasks/PersonTasksSection";

export default function TutorInfoTab({
  exportingMeetings,
  setExportingMeetings,
  tutor,
  exportingData,
  organization_id,
  orgStudents,
  setStatus,
  setError,
}: {
  exportingMeetings: boolean;
  setExportingMeetings: (boolean) => void;
  tutor: TutorAdminResponse;
  exportingData: boolean;
  organization_id: number;
  orgStudents: StudentLimitedResponse[];
  setStatus: (PageStatus) => void;
  setError: (APIResponse) => void;
}) {
  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);
  const [exportingCrmData, setExportingCrmData] = useState<boolean>(false);
  const showCrm = currently_selected_role === Auth0AccountRole.ORG_ADMIN;

  // Two of the page's three columns: Meeting History with the Data card
  // under it, then Students, Subjects, Tasks and Forms.
  return (
    <>
      <div className="flex flex-col gap-5">
        <MeetingHistory
          exportingMeetings={exportingMeetings}
          setExportingMeetings={setExportingMeetings}
          tutor={tutor}
          exportingData={exportingData}
          organization_id={organization_id}
          setStatus={setStatus}
          setError={setError}
        />
        {showCrm && (
          <div className="flex">
            <AdministrativeInfo
              exportingData={exportingCrmData}
              setExportingData={setExportingCrmData}
              userType={Auth0AccountRole.ORG_TUTOR}
              tutor={tutor}
              organization_id={organization_id}
              exportingMeetings={exportingMeetings}
              setStatus={setStatus}
              setError={setError}
            />
          </div>
        )}
      </div>

      <div className="flex flex-col gap-5">
        <Students tutor={tutor} orgStudents={orgStudents} />
        <Subjects tutor={tutor} organization_id={organization_id} />
        {showCrm && (
          <>
            <PersonTasksSection
              orgId={organization_id}
              personType={Auth0AccountRole.ORG_TUTOR}
              personId={tutor.id}
            />
            <PersonFormsSection
              orgId={organization_id}
              personType={Auth0AccountRole.ORG_TUTOR}
              personId={tutor.id}
            />
          </>
        )}
      </div>
    </>
  );
}
